{
  "instances": {
    "scheduledtasks": {
      "label": "Планировщик заданий",
      "no_scheduledtasks": "Нет запланированных заданий.",
      "cron": {
        "expression": "Выражение",
        "runnable": "Выполняемый объект",
        "title": "Крон"
      },
      "fixed_delay": {
        "initial_delay_ms": "Начальная задержка (мс)",
        "interval_ms": "Интервал (мс)",
        "runnable": "Runnable",
        "title": "Фиксированная задержка"
      },
      "fixed_rate": {
        "initial_delay_ms": "Начальная задержка (мс)",
        "interval_ms": "Интервал (мс)",
        "runnable": "Runnable",
        "title": "Фиксированный темп"
      }
    }
  }
}
